import { store } from '../../app/store';
import { CallBarState } from '../../constants/CallBarState';
import { updateCallBarState, setCallRecordingStatusData, setCallRecordingConsentData } from '../../slices/callCentre';
import TwilioVoiceService from '../../Services/TwilioVoiceService';

//const LogTitle = 'CallActivityService';

export default class CallActivityService {

  static startRecording = (callRecordId: string, twilioCall?: any) => {
    const shouldRecordCall = store.getState()?.settings?.tenantSettings?.recordAllCalls || false;

    if (shouldRecordCall) {
      store.dispatch(setCallRecordingStatusData({callRecordId: callRecordId, status: true}));
      store.dispatch(setCallRecordingConsentData({callRecordId: callRecordId, consent: true}));

      // if we have permission we start recording now it self, otherwise we start recording
      // when the user gives the consent.
      TwilioVoiceService.startRttStreaming(callRecordId, twilioCall);
    }
  }

  static resolveCallInProgressStatusChange = (notification: { id: string; twilioCall?: any }) => {
    const { id, twilioCall } = notification;
    
    store.dispatch(updateCallBarState(CallBarState.IN_PROGRESS));
    this.startRecording(id, twilioCall);
  }
}
